module.exports = __webpack_public_path__ + "static/c4-4d9c091a7cdff2fe0682aef0e9555b09.png";